
import { defineComponent } from 'vue'
import { insureDispatchList, insureDispatchDelete, addDispatch } from '@/api/insure-deduction'
import { ElMessage, ElMessageBox } from 'element-plus'
import { getAxOperateRecordListApi, getAxOperateRecordIdApi, getAxOperateRecordIdListApi } from '@/api/insure-daily-ax'
import { operationTypeList } from '../utils/insure-daily-ax-dict'
import { formatter, downloadBlobFile } from '../utils/util'

// import { operateTypeList } from '../util/insure-daily-ax-dict'
// import { formatter } from '@/utils/util'
import global from '@/utils/global'

export default defineComponent({
  name: 'InsureDailyOperateRecord',
  components: {},
  data() {
    return {
      formatter,
      formSearch: {
        operationType: '',
        projectTime: ''
      },
      operationTypeList: operationTypeList,
      pageSize: 10,
      pageNum: 1,
      total: 0,
      pagePeopleNum: 1,
      pagePeopleSize: 10,
      totalPeople: 0,
      rowObj: {} as any,
      tableData: [
        {
          name: '杨雯琦',
          idCard: '4279364919950738'
        }
      ],
      selects: [] as string[], // 列表选中
      showDrawer: false,
      tablePeopleList: []
    }
  },
  created() {
    this.initTableList()
  },
  watch: {},
  methods: {
    async initTableList() {
      console.log(this.formSearch)
      const result = await getAxOperateRecordListApi({
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        operationType: this.formSearch.operationType,
        queryStartDate: this.formSearch.projectTime ? this.formSearch.projectTime[0] : '',
        queryEndDate: this.formSearch.projectTime ? this.formSearch.projectTime[1] : ''
      })

      this.total = result.totalCount
      this.tableData = result.list
    },
    onSearch() {
      this.initTableList()
    },
    onReset() {
      this.formSearch = {
        operationType: '',
        projectTime: ''
      }
      this.pageNum = 1
      this.onSearch()
    },
    handleSizeChange() {
      this.pageNum = 1
      this.initTableList()
    },

    async onDetailExport() {
      this.onExport(this.rowObj.id)
    },
    // 导出投保记录列表
    async onExport(id: string) {
      const res = await getAxOperateRecordIdApi(id)
      downloadBlobFile(res)
    },
    onAddInsure(row) {
      console.log('行内 续保', row)
    },
    // 点击操作属性
    async onClickType(row) {
      this.rowObj = row
      await this.initPeopleList()
      this.showDrawer = true
    },
    async initPeopleList() {
      const result = await getAxOperateRecordIdListApi({
        pageSize: this.pagePeopleSize,
        pageNum: this.pagePeopleNum,
        operateRecordId: this.rowObj.id
      })
      console.log('点击操作属性 打开抽屉弹框', this.rowObj.id, result)
      this.totalPeople = result.totalCount
      this.tablePeopleList = result.list
    },
    goBack() {
      this.showDrawer = false
    },
    handleSelectionChange(selects: { id: string }[]) {
      this.selects = selects.map((item) => item.id)
    }
  }
})
